<template>
  <div>
    <div>
      <ejs-tab ref='mmlTab' @selected='tabClicked($event)' :selecting='mmlTabSelect' height='328'>
      </ejs-tab>
    </div>
    <!-- 都是被逼的，复用一个模板tab组件会有bug !-->
    <div v-for='command in currentMo.commands' :key='command.name' :id="'mml-'+command.name" style='display: none'>
      <template v-if='showUadForm'>
        <uad-form :ref="'mml-'+command.name" :formName='command.name' @ready-to-exec='readyToExec' @sync-time='syncTime'></uad-form>
      </template>
      <template v-else>
        <oper-form :ref="'mml-'+command.name" :formName='command.name' @ready-to-exec='readyToExec' @sync-time='syncTime'></oper-form>
      </template>
    </div>
    <div id='codemirror' style='display: none'>
      <command-editor ref='mmlEditor' @ready-to-exec='readyToExec'></command-editor>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import OperForm from '@/components/mmlconfig/rightPanel/OperForm';
import UadForm from '@/components/mmlconfig/rightPanel/UadForm';
import CommandEditor from '@/components/mmlconfig/rightPanel/CommandEditor';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'command-exec',
  components: {
    OperForm,
    UadForm,
    CommandEditor
  },
  data() {
    return {
      execTime:0
    };
  },
  created() {
    bus.$on('add2CmdEditor', mmlList => {
      mmlList.forEach(mml => {
        this.$refs.mmlEditor.addMML(mml);
      });
      // select the cmd tab
      this.$refs.mmlTab.select(this.currentMo.commands.length);
    });
  },
  computed: {
    ...mapGetters(['currentMo', 'massModifyMode']),
    showUadForm() {
      return ['etccfgdata', 'eNodebcfgdata','cfgdata', 'gNBCfgData'].includes(this.currentMo.moName.toLowerCase());
    }
  },
  methods: {
    ...mapMutations(['changeMo', 'changeMassModMode']),
    changeName(name){
      if(name ==='DOWNLOAD'){
         return 'IMPORT';
      }else if(name ==='UPLOAD'){
         return 'EXPORT';
      }else if(name ==='上载'){
         return '导出';
      }else if(name ==='下载'){
         return '导入';
      }else{
        return name;
      }
    },
    tabClicked(e) {
      // 切換tab页时重置批量修改模式
      this.changeMassModMode(false);
      const tabItemsArr = this.$refs.mmlTab.ej2Instances.items;
      const { command } = tabItemsArr[e.selectedIndex];
      if (command && this.showUadForm) {
        this.$refs[`mml-${command.name}`][0].setInitParams(this.currentMo, command);
      } else if (command) {
        this.$refs[`mml-${command.name}`][0].refreshFormTrigger(command);
      } else {
        this.$refs.mmlEditor.refreshCmd();
      }
    },
    syncTime(execTime) {
      this.execTime = execTime;
      console.log("syncTime",execTime)
      this.$emit('sync-time',this.execTime);
    },
    mmlTabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    refreshTabs(moData) {
      if (!moData) { return; }
      // store moData in vuex
      this.changeMo(moData);
      const commands = JSON.parse(JSON.stringify(this.currentMo.commands));
      if (this.showUadForm) {
        // 服了 这个上传下载表单的命令竟然和适配包里是相反的，我真是醉了
        commands.reverse();
      }
      // 当没有命令时返回，不展示Cmd
      if (commands.length <= 0) {
        return;
      }
      // add command attr in each tab
      if(moData.moName=="eNodeBCfgData"){
        for(const sty in commands ){
            if(commands[sty].name=="DLD"){
              commands[sty].zhName = "导入";
              commands[sty].enName ="IMPORT"
           }else if(commands[sty].name=="UPLD"){
              commands[sty].zhName = "导出";
              commands[sty].enName ="EXPORT";
           }
       }
      }

      for(const sty in commands ){
            if(commands[sty].name=="DSP" && commands[sty].zhName ==null){
              commands[sty].zhName = "显示";
              commands[sty].enName ="DISPLAY"
           }
       }
    if(moData.moName=="PatchMgmt"){
        for(const sty in commands ){
            if(commands[sty].name=="DSP"){
              commands[sty].zhName = "查询";
              commands[sty].enName ="DISPLAY"
           }
       }
      }

      const tabObj = commands.map(cmd => (
        { command: cmd, header: { text: this.LOCALE === 'zh'? `${cmd.zhName}`:`${cmd.enName}` }, content: `#mml-${cmd.name}` }
      ));
      tabObj.push({ header: { text: this.LOCALE === 'zh'?'命令行':'CMD' }, content: '#codemirror' });
      this.$refs.mmlTab.ej2Instances.items = tabObj;
      // 需要等待tab绑定的dom加载完再执行refresh操作，否则可能绑定失败
      this.$nextTick(() => {
        this.$refs.mmlTab.ej2Instances.refresh();
        // trigger the first tab selected event
        if (!this.showUadForm) {
          this.$refs[`mml-${commands[0].name}`][0].refreshFormTrigger(commands[0]);
        }
        if (this.showUadForm) {
          this.$refs[`mml-${commands[0].name}`][0].setInitParams(this.currentMo, commands[0]);
        }
      });
    },
    
    execAndExitMassMod() {
      this.$refs['mml-MOD'][0].changeToSingle();
    },
    readyToExec(cmdList, cmdMode) {
      console.log("readyToExec cmdMode",cmdMode)
      this.$emit('do-exec', cmdList, cmdMode);
    },
  },
  beforeDestroy() {
    bus.$off('add2CmdEditor');
  },
};
</script>
<style>

</style>
